import { Box, Button, useMediaQuery } from "@chakra-ui/react";
import {useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import LoginDrawerSection from "./LoginDrawerSection";
import {useSettingsContext} from "../../../contexts/SettingsContext";
import {useIntl} from "react-intl";

interface WallpapersInterface {
  setBackground: Function;
  background: number | string;
  isLoggedIn: boolean;
  sdk: any;
}

interface SkinInterface {
  id: string,
  data: {
    background: string,
    thumbnail: string,
    color: {iv: string},
    name: {iv: string}
  }
}

function WallpapersView(props: WallpapersInterface) {
  const { sdk, setBackground, background, isLoggedIn } = props;
  const [isLargeScreen] = useMediaQuery("(min-width: 764px)");
  const intl = useIntl();

  const { setSkin } = useSettingsContext();

  const [data, setData] = useState<SkinInterface[]>([]);
  useEffect(() => {
    const fetchSkins = async () => {
      const skins = await sdk.getDataManager().getSkins();
      setData(skins && Array.isArray(skins) ? skins : []);
    }
    isLoggedIn && fetchSkins();
  }, [isLoggedIn, sdk]);

  const navigate = useNavigate();

  const emptyBlocks = new Array(4 - data.length > 0 ? 4 - data.length : 0).fill({
    bg: "#f5f3ef",
      image: `wallpapers/Locked.png`,
  });

  const onSelectBg = (id: number | string) => {
    sdk.getAnalytics().push({action: "change", event: "skin", id: id, language: intl.locale});
    setBackground(id);
  };

  const login = () => {
    navigate("/", { replace: true });
  };

  return (
    <Box>
      <Box
        p={6}
        display={"grid"}
        gridTemplateColumns="repeat(2, 1fr)"
        gridGap={2}
      >
        {data?.map((item) => (
          <Button
            key={item.id}
            style={{borderRadius: 8, overflow: 'hidden'}}
            width={"100%"}
            height={isLargeScreen ? "120px" : "96px"}
            bg={item.data?.color?.iv}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            padding={0}
            border={item.id === background ? "2px solid" : ""}
            borderColor={item.id === background ? "#FFCD35" : ""}
            cursor={"pointer"}
            onClick={() => {
              onSelectBg(item.id)
              setSkin(item)
            }}
            sx={{
              "&:focus": {
                bg: item.data?.color?.iv,
              },
              "&:hover": {
                bg: item.data?.color?.iv,
              },
            }}
            position={"relative"}
          >
            <img src={`${item.data?.thumbnail}`} className="wallpaper" alt={item.data?.name?.iv} />
            {item.id === background && (
              <Box
                borderRadius={"8px 0px 0px 0px"}
                bg={"#FFCD35"}
                width={isLargeScreen ? "36px" : "28px"}
                height={isLargeScreen ? "36px" : "28px"}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                bottom={0}
                right={0}
                position={"absolute"}
              >
                <img src={`${process.env.REACT_APP_BASE_URL}/Check.png`} className="wallpaper" alt="check" />
              </Box>
            )}
          </Button>
        ))}
        {emptyBlocks.map((item, idx) => (
          <Box
            key={idx}
            width={"100%"}
            height={isLargeScreen ? "120px" : "96px"}
            bg={item.bg}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            borderRadius={16}
            cursor={"not-allowed"}
          >
            <img src={`${process.env.REACT_APP_BASE_URL}/${item.image}`} className="wallpaper" alt="Math" />
          </Box>
        ))}
      </Box>
      {!isLoggedIn && (
        <LoginDrawerSection
          description={{
            id: "login-and-change-wallpaper",
            defaultMessage:
              "Connecte-toi pour changer ton fond d’écran.",
          }}
        />
      )}
    </Box>
  );
}

export default WallpapersView;
